import { formatPrice } from '../utils/formatPrice';

interface PriceSet {
  displayPrice: string;
  crossedOutPrice: string | null;
}

export const getPriceSet = (price: string, uncPrice?: string): PriceSet => {
  const parsedDiscountPrice: number = parseFloat(price);
  if (!uncPrice) {
    return {
      displayPrice: formatPrice(parsedDiscountPrice),
      crossedOutPrice: null,
    };
  }

  const parsedUncPrice: number = parseFloat(uncPrice);

  return parsedDiscountPrice < parsedUncPrice
    ? {
        displayPrice: formatPrice(parsedDiscountPrice),
        crossedOutPrice: formatPrice(parsedUncPrice),
      }
    : {
        displayPrice: formatPrice(parsedUncPrice),
        crossedOutPrice: null,
      };
};

export const getPriceForSort = (price: string, uncPrice?: string): number => {
  const parsedDiscountPrice: number = parseFloat(price);
  if (!uncPrice) {
    return parsedDiscountPrice;
  }

  const parsedUncPrice: number = parseFloat(uncPrice);

  return parsedDiscountPrice < parsedUncPrice ? parsedDiscountPrice : parsedUncPrice;
};
